import { Component, Input, OnInit } from '@angular/core';
import { SteamUseUnitOperation } from '../../../_models/_unit-operations/steam-use-unit-operation';
import { FlowsheetService } from '../../../_services/flowsheet.service';
import { SteamContributorCodeProvider } from '../../../_services/custom-code-providers/steam-contributor-code-provider';

@Component({
  selector: 'sob-steam-use-utility',
  templateUrl: './steam-use-utility.component.html',
  styleUrls: ['./steam-use-utility.component.css'],
})
export class SteamUseUtilityComponent implements OnInit {
  @Input()
  unitOperation: SteamUseUnitOperation;

  defaultCodeProvider: SteamContributorCodeProvider;
  isOpened = false;
  constructor(private flowsheetService: FlowsheetService) {
    this.defaultCodeProvider = new SteamContributorCodeProvider();
  }

  ngOnInit() {}

  saveSteamCustomModel(res: any) {
    if (res.instanceId === 'steamCodeEditor') {
      this.unitOperation.steamModelScript = res.code;
      this.flowsheetService.saveCustomCodeChanges();
    }
  }

  switchOpened() {
    $('#steamDiv').collapse('toggle');
    this.isOpened = !this.isOpened;
  }
}
